export default "__VITE_ASSET__C$UoYikQ__"